import React from 'react';

import classes from './UploadBannerModal.module.scss';
import { UploadImageModal } from '../../../../shared/components/modals';
import { LoadedFile } from '../../../../shared/interfaces/LoadedFile';
import { challengeBannerService } from '../../../services/challengeBannerService';
import { ChallengeBannerUploadType } from '../../../constants/challengeBannerUploadType';

type UploadBannerModalProps = {
  bannerType: ChallengeBannerUploadType;
  getImage: () => Promise<LoadedFile | undefined | null>;
  onSave: (banner: LoadedFile) => Promise<void>;
  onRemove: (deletedBanner: LoadedFile) => Promise<void>;
  onClose: () => void;
};

const titles: Record<ChallengeBannerUploadType, string> = {
  CHALLENGE_BANNER_WEB: 'Upload Banner for Web',
  CHALLENGE_BANNER_MOBILE: 'Upload Banner for Mobile',
};

const descriptions: Record<ChallengeBannerUploadType, string> = {
  CHALLENGE_BANNER_WEB: 'Recommended size: 948x380 px',
  CHALLENGE_BANNER_MOBILE: 'Recommended size: 343x158 px',
};

const UploadBannerModal = ({
  bannerType,
  getImage,
  onSave,
  onRemove,
  onClose,
}: UploadBannerModalProps) => {
  const uploadImage = async (file: File): Promise<LoadedFile> =>
    challengeBannerService.uploadBanner(bannerType, file, {
      isRunGlobalSpinner: false,
    });

  return (
    <UploadImageModal
      open
      title={titles[bannerType]}
      description={
        <>
          Upload a banner that represents your challenge.
          <br />
          It will appear at the top of the challenge page.
        </>
      }
      uploadDescription={descriptions[bannerType]}
      renderPreview={(logoUrl) => (
        <img src={logoUrl} alt="Banner" className={classes.banner} />
      )}
      onClose={onClose}
      getImage={getImage}
      uploadImage={uploadImage}
      removeImage={onRemove}
      saveImage={onSave}
    />
  );
};

export { UploadBannerModal };
